import React from 'react';
import { Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { useChartsCardStyles } from './chartsCard.style';
import { DateTime } from 'luxon';

const ChartsCard = ({
  title,
  children,
  spaceRight = false,
  options = [],
  selectedOption,
  onChangeSelectedValue,
}) => {
  const classes = useChartsCardStyles(spaceRight);
  const dateToday = DateTime.now().toFormat('dd LLLL');
  const datePrev = DateTime.now()
    .minus({ days: selectedOption })
    .toFormat('dd LLLL');

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.chartContainer }}>
        <div className={classes.header}>
          <Typography classes={{ root: classes.title }}>{title}</Typography>
          {options && options.length ? (
            <Select
              value={selectedOption}
              onChange={onChangeSelectedValue}
              className={classes.durationSelect}
              autoWidth
            >
              {options.map(({ value, label }) => (
                <MenuItem
                  classes={{ root: classes.durationSelect }}
                  value={value}
                >
                  {label}
                </MenuItem>
              ))}
            </Select>
          ) : null}
        </div>
        {options && options.length ? (
          <Typography classes={{ root: classes.subtitle }}>
            {datePrev} - {dateToday} ({selectedOption} days)
          </Typography>
        ) : null}
        {children}
      </Grid>
    </Grid>
  );
};

export default ChartsCard;
